import 'Utils/responsiveHelper';

export default function initImagesIndent() {
	const win = jQuery(window);

	jQuery('.section-floorplans').each(function() {
		const section = jQuery(this);
		const image = section.find('.desktop-block');

		ResponsiveHelper.addRange({
			'..1023': {
				on: function() {
					win.off('resize orientationchange', setImageIndent);
					image.removeAttr('style');
				}
			},
			'1024..': {
				on: function() {
					setImageIndent();
				}
			}
		});

		function setImageIndent() {
			if (section.hasClass('align-right')) {
				image.css({
					margin: `0 -${image.outerWidth() / 2}px -${image.outerHeight() / 2}px 0`
				});
			} else {
				image.css({
					margin: `0 0 -${image.outerHeight() / 2}px -${image.outerWidth() / 2}px`
				});
			}
		}

		win.on('resize orientationchange', setImageIndent);
	});
}